import React from 'react';
import { Navigate } from 'react-router-dom';
import { useEvents } from './CustomersContext';

const StaffAccessRoute = ({ children }) => {
  const { hasAccessibleStaffMembers } = useEvents();
  const hasStaffAccess = hasAccessibleStaffMembers();

  if (hasStaffAccess === null) {
    return <div></div>;
  }

  if (!hasStaffAccess) {
    return <Navigate to="/manage/statistics" replace />;
  }

  return children;
};

export default StaffAccessRoute;
